var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolyChart2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 2.99978C18 2.73457 18.1053 2.48021 18.2929 2.29268C18.4804 2.10514 18.7348 1.99978 19 1.99978C19.2652 1.99978 19.5196 2.10514 19.7071 2.29268C19.8946 2.48021 20 2.73457 20 2.99978V10.9998C20 11.265 19.8946 11.5194 19.7071 11.7069C19.5196 11.8944 19.2652 11.9998 19 11.9998H11C10.7348 11.9998 10.4804 11.8944 10.2929 11.7069C10.1053 11.5194 9.99999 11.265 9.99999 10.9998C9.99999 10.7346 10.1053 10.4802 10.2929 10.2927C10.4804 10.1051 10.7348 9.99978 11 9.99978H16.59L11 4.40978L7.69999 7.70978C7.51306 7.89301 7.26174 7.99564 6.99999 7.99564C6.73824 7.99564 6.48692 7.89301 6.29999 7.70978L0.29999 1.70978C0.134712 1.51966 0.0472826 1.27416 0.0551794 1.02237C0.0630761 0.770569 0.165718 0.531031 0.342584 0.351638C0.519451 0.172245 0.757509 0.0662157 1.00917 0.0547484C1.26083 0.043281 1.50754 0.12722 1.69999 0.289784L6.99999 5.59978L10.3 2.29978C10.4869 2.11656 10.7382 2.01393 11 2.01393C11.2617 2.01393 11.5131 2.11656 11.7 2.29978L18 8.59978V2.99978Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolyChart2);
export default __webpack_public_path__ + "static/media/poly_chart_2.d8543344833f20ee03902556d61248ca.svg";
export { ForwardRef as ReactComponent };